<p>edit-program-from-stock works!</p>
